/** A download that failed verification; fetching it again returns the same bytes. */
export class VerificationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VerificationError';
  }
}
